// extracted by mini-css-extract-plugin
module.exports = {"waveContainer":"styles_waveContainer__1TSaj","wave":"styles_wave__1P35V","waves":"styles_waves__qPG3F"};